module.exports = "<div class=\"expandable-header-container\">\n    <ng-content></ng-content>\n</div>"